// Blog data - can be loaded from JSON or API in the future

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  image: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: 'post-1',
    slug: 'post-1',
    title: 'Post 1 Headline',
    excerpt: 'Post 1 excerpt...',
    content: 'Post 1 content...',
    date: '2024-01-01',
    image: '/images/default-image.jpg'
  },
  {
    id: 'post-2',
    slug: 'post-2',
    title: 'Post 2 Headline',
    excerpt: 'Post 2 excerpt...',
    content: 'Post 2 content...',
    date: '2024-01-02',
    image: '/images/default-image.jpg'
  },
  {
    id: 'post-3',
    slug: 'post-3',
    title: 'Post 3 Headline',
    excerpt: 'Post 3 excerpt...',
    content: 'Post 3 content...',
    date: '2024-01-03',
    image: '/images/default-image.jpg'
  },
  {
    id: 'post-4',
    slug: 'post-4',
    title: 'Post 4 Headline',
    excerpt: 'Post 4 excerpt...',
    content: 'Post 4 content...',
    date: '2024-01-04',
    image: '/images/default-image.jpg'
  },
  {
    id: 'post-5',
    slug: 'post-5',
    title: 'Post 5 Headline',
    excerpt: 'Post 5 excerpt...',
    content: 'Post 5 content...',
    date: '2024-01-05',
    image: '/images/default-image.jpg'
  }
];

export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

export const getAllPosts = (): BlogPost[] => {
  return blogPosts;
};
